import React from "react";
import { connect } from "react-redux";
import {
  hideRemoveContributorDialog,
  removeContributor,
} from "edit-media/redux/editMediaActions";
import {
  getContributor,
  getContributorRoles,
  getRemoveContributorDialogIndex,
  getRemoveContributorDialogVisible,
} from "common/selectors";
import { formatContributorName } from "util/stringFormat";
import ConfirmationDialog from "components/ConfirmationDialog";

const RemoveContributorDialog = ({
  contributor,
  contributorRoles,
  index,
  onCancel,
  onConfirm,
  visible,
}) => (
  <ConfirmationDialog
    title={"Are you sure?"}
    message={`Are you sure you want to remove: ${formatContributorName(
      contributor,
    )}?`}
    confirmButtonText="Yes"
    onCancel={onCancel}
    onConfirm={onConfirm(index)}
    visible={visible}
  />
);

const mapState = state => {
  const index = getRemoveContributorDialogIndex(state);
  const visible = getRemoveContributorDialogVisible(state);
  const contributor = getContributor(index, state);
  const contributorRoles = getContributorRoles(state);

  return {
    contributor,
    contributorRoles,
    index,
    visible,
  };
};

const mapDispatch = dispatch => ({
  onConfirm: index => () => dispatch(removeContributor(index)),
  onCancel: () => dispatch(hideRemoveContributorDialog()),
});

export default connect(mapState, mapDispatch)(RemoveContributorDialog);
